export enum DeviceUserPermission {
  OWNER,
  INSTALLER,
  ADMIN,
  VIEWER,
}
